import { defineStore } from "pinia"
import { computed, ref } from "vue"

export type DetailPanelType = "opportunity" | "parcels" | "transaction" | "layers"

// only one panel is ever active at a time; opening one implicitly hides any other
export const useDetailPanelStore = defineStore("detailPanel", () => {
	const active = ref<DetailPanelType | null>(null)
	const collapsed = ref(false)

	const isOpen = computed(() => (type: DetailPanelType) => active.value === type)
	const isCollapsed = computed(() => (type: DetailPanelType) => active.value === type && collapsed.value)

	function open(type: DetailPanelType) {
		active.value = type
		collapsed.value = false
	}

	// no-op if a different panel is active, so callers can call this unconditionally
	function close(type: DetailPanelType) {
		if (active.value !== type) return
		active.value = null
		collapsed.value = false
	}

	function collapse() {
		collapsed.value = true
	}

	function expand() {
		collapsed.value = false
	}

	return {
		active,
		isOpen,
		isCollapsed,
		open,
		close,
		collapse,
		expand,
	}
})
